import api from "@/api";

/**
 * Handles the POST to /api/modal/exit-subscribe/capture for the
 * e-mail exit method. Thin wrapper around the API client that
 * normalizes success/error shapes and marks the local store so the
 * modal does not immediately reappear for the same visitor.
 */
export function useSubscribeExitCapture() {
  const store = subscribeExitStore();

  async function submit(payload: {
    subscribe_exit_id: number;
    email: string;
    locale: string;
    consent: boolean;
    website?: string;
  }) {
    try {
      const { data } = await api.post("modal/exit-subscribe/capture", {
        subscribe_exit_id: payload.subscribe_exit_id,
        email: payload.email,
        locale: payload.locale,
        consent: payload.consent,
        website: payload.website ?? "",
      });
      if (data?.ok) {
        store.markEmailSubmitted(payload.subscribe_exit_id, payload.email);
      }
      return {
        ok: Boolean(data?.ok),
        message: data?.message ?? "",
        status: data?.status ?? "",
      };
    } catch (err: any) {
      const resp = err?.response?.data;
      return {
        ok: false,
        message: resp?.message ?? "Não foi possível enviar.",
        status: resp?.status ?? "error",
      };
    }
  }

  return { submit };
}
